/**
 * Created by DejanK on 3/20/2017.
 */
export default UserRepository

UserRepository.$inject = ['MainServer'];
function UserRepository(MainServer){
  const $repo = this;

  $repo.getCurrentUser = () => { return MainServer.get('current-user') };
  $repo.listCurrentUserUserAccounts = () => { return MainServer.get('current-user/user-accounts')};
  $repo.disableTutorial = (tutorialName) => { return MainServer.delete(`current-user/tutorials/${tutorialName}`)};
  $repo.switchToAccount = (accountId) => { return MainServer.post('current-user/account', {accountId: accountId})};
  $repo.updateBasicProfile = (data) => { return MainServer.put('current-user/basic-info', data)}
  $repo.updateUserEmailAddress = data => MainServer.put('current-user/email-address', data)
  $repo.updateUserPassword=(data) =>{return MainServer.put('current-user/password',data)}
  $repo.updateProfilePicture = fd => MainServer.sendFile('current-user/profile-picture', fd)
}
